module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "clients"
    }
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('h2', {
    staticClass: "heading-light",
    domProps: {
      "innerHTML": _vm._s(_vm.clients.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.displayclients), function(client, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-4 client-object"
    }, [_c('object', {
      staticClass: "cls-1",
      attrs: {
        "data": 'static/img/content/logos/' + client.logo,
        "type": "image/svg+xml"
      }
    })])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7931c66c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientSection.vue
// module id = 144
// module chunks = 2